import * as types from 'modules/checklists/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDetailsIsLoadingReducer = boolean;

const initialState: ChecklistUiDetailsIsLoadingReducer = false;

const set = (): ChecklistUiDetailsIsLoadingReducer => true;

const reset = (): ChecklistUiDetailsIsLoadingReducer => false;

export default createReducer(initialState, {
  [types.SET_IS_NEW]: reset,
  [types.FETCH_REQUEST]: set,
  [types.FETCH_SUCCESS]: reset,
  [types.UPDATE_SUCCESS]: reset,
  [types.UPDATE_REQUEST]: set,
  [types.CREATE_REQUEST]: set,
  [types.CREATE_SUCCESS]: reset,
  [types.UPDATE_FAILURE]: reset,
});
